<template>
    <b-row>
        <b-col :sm="!menuPermission('update') && !menuPermission('add') ? '12' : '8'">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title text-primary"><strong>List Master Activity</strong></h4>
              </template>
              <template v-slot:body>
                <b-form-group
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    style="width: 200px;"
                    type="text"
                    placeholder="Search..."
                    v-model="params.name"
                  ></b-form-input>
                </b-form-group>
                <div v-if="loading" class="text-center my-5">
                  <b-spinner type="grow" label="Spinning"></b-spinner>
                </div>
                <template v-else>
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th width="10%">No</th>
                          <th width="25%">Name</th>
                          <th width="25%">Alias</th>
                          <th width="25%">Activity Flag</th>
                          <th width="10%">Active</th>
                          <th width="15%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(p, i) in filteredTableData" :key="`p-${i}`">
                          <td class="text-center">{{ startRowIndexData + i }}</td>
                          <td>{{ p.name }}</td>
                          <td>{{ p.alias ? p.alias : '-' }}</td>
                          <td>{{ p.activity_flag ? p.activity_flag : '-' }}</td>
                          <td>{{ p.is_active === true ? 'Active' : 'Inactive' }}</td>
                          <td class="d-flex">
                            <b-button
                              v-if="menuPermission('update')"
                              variant="success"
                              size="sm"
                              class="mr-2"
                              @click="onEditActivity(p)"
                              ><i class="fa fa-edit"></i
                            ></b-button>
                            <b-button
                              v-if="menuPermission('delete')"
                              variant="danger"
                              size="sm"
                              @click="onDeleteActivity(p)"
                            >
                              <i
                                v-if="!loading_delete"
                                class="fa fa-trash"
                              ></i>
                              
                              <span v-else
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="displayedData.length > 0">
                    <b-pagination
                      v-model="data.currentPage"
                      :total-rows="totalData"
                      :per-page="data.perPage"
                      aria-controls="my-table"
                      align="center"
                      first-number
                    />
                  </div>
                  <p v-else class="text-center my-4">No activity data found.</p>
                </template>
              </template>
            </iq-card>
        </b-col>
        <b-col sm="4"
          v-if="menuPermission('update') || menuPermission('add')">
          <iq-card
            :class="{
              'border border-danger shadow-lg': edit_mode,
            }"
          >
            <template v-slot:headerTitle>
              <h4 class="card-title text-primary"
                ><strong>{{ edit_mode ? 'Edit' : 'Add' }} Activity</strong></h4
              >
            </template>
            <template v-slot:body>
              <b-form @submit.prevent="submitFormActivity">
                <b-form-group
                  label="Name Activity"
                  label-for="name_activity"
                >
                  <b-form-input
                    id="name_activity"
                    type="text"
                    placeholder="Type text..."
                    maxlength="30"
                    v-model="form.name"
                  ></b-form-input>
                </b-form-group>
  
                <b-form-group
                  label="Alias Activity"
                  label-for="alias_activity"
                >
                  <b-form-input
                    id="alias_activity"
                    type="text"
                    placeholder="Type text..."
                    maxlength="30"
                    v-model="form.alias"
                  ></b-form-input>
                </b-form-group> 

                <b-form-group
                  label="Activity Flag"
                  label-for="alias_activity"
                >
                    <b-form-select
                        plain
                        v-model="form.activity_flag"
                        size="sm"
                        class="col-md-12"
                    >
                        <template v-slot:first>
                        <b-form-select-option :value="''">Select Activity Flag</b-form-select-option>
                        <b-form-select-option :value="'running'">Running</b-form-select-option>
                        <b-form-select-option :value="'delay'">Delay</b-form-select-option>
                        <b-form-select-option :value="'finish'">Finish</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group> 
                
  
                <b-form-group label="Is Active" label-for="is_active_activity">
                  <b-form-checkbox
                    id="is_active_activity"
                    v-model="form.is_active"
                    name="is_active"
                    switch
                    inline
                  >
                    {{ form.is_active ? 'Active' : 'Inactive' }}
                  </b-form-checkbox>
                </b-form-group>
                <hr />
                <b-form-group class="text-right">
                  <b-button type="submit" variant="primary">
                    <span v-if="!loading_submit">{{
                      edit_mode || !menuPermission('add') ? 'Save' : 'Add'
                    }}</span>
                    <template v-else>
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </template>
                  </b-button>
                  <b-button
                    type="button"
                    variant="danger"
                    class="iq-bg-danger ml-3"
                    @click.prevent="resetFormActivity"
                    >Cancel</b-button
                  >
                </b-form-group>
              </b-form>
            </template>
          </iq-card>
        </b-col>
    </b-row>
</template>

<script>
import { srActions } from '@src/Utils/helper'
import _ from 'lodash'

export default {
  name: 'SrMasterActivity',
  data () {
    return {
        loading:false,
        loading_delete:false,
        loading_submit:false,

        edit_mode:false,

        params:{
            name:''
        },

        data: {
            currentPage: 1,
            perPage: 10,
            data:[]
        },

        selected_id:null,
        form: {
            name:'',
            alias:'',
            activity_flag:'',
            is_active:true,
        }
    }
  },
  computed: {
    totalData() {
      return this.data.data.length;
    },
    displayedData() {
      const start = (this.data.currentPage - 1) * this.data.perPage;
      const end = start + this.data.perPage;
      return this.data.data.slice(start, end);
    },
    startRowIndexData() {
      return (this.data.currentPage - 1) * this.data.perPage + 1;
    },
    filteredTableData() {
    if (this.params.name) {
      const searchRegex = new RegExp(this.params.name, 'i'); // case-insensitive search
      return this.displayedData.filter(item => searchRegex.test(item.name));
    } else {
      return this.displayedData; // no search query, return all data
    }
  }
  },
  async mounted () {
   await this.fetchMasterActivity()
  },
  methods: {
   ...srActions,
    menuPermission (output) {
       const { menuObject } = this.$route.query
    
       if (!menuObject) {
         return true
       }
    
       return JSON.parse(window.atob(menuObject))[output]
    },
    onEditActivity (activity) {
        this.edit_mode = true
        this.selected_id = activity.id
        this.form = {
          name: activity.name,
          alias: activity.alias,
          activity_flag: activity.activity_flag,
          is_active: activity.is_active  === true ? true : false,
        }
    },
    onDeleteActivity (payload) {
        this.$swal({
          title: 'Delete Activity?',
          text: `Activity ${payload.name} will be deleted and cannot be recovered.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Delete'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loading_delete = true
            let res = await this.deleteMasterActivity({id:payload.id})
            if (res.status != 'success') {
              this.loading_delete = false
              this.$swal(
                  'Oops!',
                  'Something wrong with the server. Please try again later.',
                  'error'
                )
            } else {
              this.loading_delete = false
              this.fetchMasterActivity()
              this.$swal(
                `Activity deleted!`,
                `Activity ${payload.name} successfully deleted`,
                'success'
              )
            }
          }
        })
    },
    resetFormActivity () {
        this.edit_mode = false
        this.form = {
            name:'',
            alias:'',
            activity_flag:'',
            is_active: true,
        }
    },
    async fetchMasterActivity () {
        this.loading = true

        const res = await this.getMasterActivity()

        if(res.status === 'success'){
            this.data.data = res.data
        }        

        this.loading = false
    },
    async submitFormActivity () {
        this.loading_submit = true
  
        let payload = {
          id: this.selected_id,
          data: {
            name: this.form.name,
            alias: this.form.alias,
            activity_flag: this.form.activity_flag,
            is_active: this.form.is_active === true ? true : false,
          }
        }
  
        let form_has_empty_value = false
        for (var key in payload.data) {
          if (payload.data[key] === '') form_has_empty_value = true
          else if (Array.isArray(payload.data[key]) && !payload.data[key].length) { form_has_empty_value = true }
        }
  
        if (form_has_empty_value) {
          this.$swal(
            'Empty form!',
            'Please check again and fill all the forms.',
            'error'
          )
        } else {
          if (!this.edit_mode) {
            let res = await this.createMasterActivity({data: payload.data})
            if (res.status == 'success') {
              this.resetFormActivity()
              this.fetchMasterActivity()
              this.$swal(
                'Activity added!',
                'Activity added successfully.',
                'success'
              )
            } else {
                this.$swal(
                  'Oops!',
                  'Something wrong with the server. Please try again later.',
                  'error'
                )
            }
          } else {  
            let res = await this.updateMasterActivity(payload)
            console.log(res)
            if (res.status == 'success') {
              this.resetFormActivity()
              this.fetchMasterActivity()
              this.$swal(
                'Activity updated!',
                'Activity updated successfully.',
                'success'
              )
            } else {
                this.$swal(
                  'Oops!',
                  'Something wrong with the server. Please try again later.',
                  'error'
                )
            }
          }
        }
        this.loading_submit = false
      },

  }
}
</script>